module.exports = __webpack_public_path__ + "img/flow.149b888e.jpg";